import {useNotificationsQuery, useUpdateNotifications} from '#apollo/schema';
import RectangleSkeleton from '#component/base/skeletons/RectangleSkeleton';
import {NotificationsForm} from '#component/form';
import {AuthCTAMessages} from '#component/partial';
import {useToastQueue} from '#hook';

import {ctaNotification, formCustom, notificationWrapper} from './NotificationTab.css';

const NotificationTab = () => {
  const {data, loading} = useNotificationsQuery();
  const {addToast} = useToastQueue();
  const [updateNotifications] = useUpdateNotifications();
  const {receiveEmailNotification, receiveSMSNotification} = data?.me || {};

  const handleSubmit = async ({
    receiveEmailNotification = false,
    receiveSMSNotification = false,
  }) => {
    await updateNotifications({
      variables: {input: {receiveEmailNotification, receiveSMSNotification}},
    });
    addToast({children: 'Notification settings updated!'});
  };
  return !loading ? (
    <div className={notificationWrapper}>
      <AuthCTAMessages
        title="Notifications"
        className={ctaNotification}
        titleColor="burgundy"
        titleVariant="heading3"
        messages={[
          'By opting into notifications, Tally Health™ can help you stay on-track with reminders throughout your journey.',
          'Any account updates are deemed essential and will be communicated via email regardless of notification selections.',
        ]}
      />
      <NotificationsForm
        onSubmit={handleSubmit}
        receiveEmailNotification={receiveEmailNotification}
        receiveSMSNotification={receiveSMSNotification}
        className={formCustom}
      />
    </div>
  ) : (
    <RectangleSkeleton width={1400} height={600} />
  );
};

export default NotificationTab;
